import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { loadStaticPageContent } from 'redux/StaticPages/actions';
import { ssrHandler } from 'utils';

import PartnersTemplate from './PartnersTemplate';

const MOBILE_WIDTH = 580;
const PAGE_NAME = 'partners';

class Partners extends PureComponent {
  render() {
    if (!this.props.page || !this.props.page.data) {
      return null;
    }

    return (
      <PartnersTemplate
        content={this.props.page.data}
        isMobile={this.props.isMobile}
        onCardClick={this.props.subnavigationOpen}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isMobile: state.app.width < MOBILE_WIDTH,
  page: state.staticPages.items.find(({ name }) => name === PAGE_NAME)
});

function loadPartnersData(store, nextState, replace, callback) {
  const { staticPages } = store.getState();
  const page = staticPages.items.find(({ name }) => name === PAGE_NAME);

  // if (typeof page !== 'undefined') {
  //   return callback();
  // }

  const actions = [loadStaticPageContent(PAGE_NAME)];

  ssrHandler(store.dispatch, actions, callback);
}

export default (store) => ({
  path: '/we/partners/',
  component: connect(mapStateToProps)(Partners),
  onEnter: loadPartnersData.bind(null, store)
});



// WEBPACK FOOTER //
// ./src/components/Partners/index.js